webpackJsonp([1],{

/***/ "/DrB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"register"}},[_c('div',{attrs:{"id":"form__container"}},[_c('form',[_c('h3'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"email","required":"","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('h3'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","required":"","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('h3'),_vm._v(" "),_c('div',[(_vm.error)?_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error)+" ")]):_vm._e()]),_vm._v(" "),_c('h3'),_vm._v(" "),_c('div',{attrs:{"id":"button_Container"}},[_c('b-button',{attrs:{"id":"button","disabled":!_vm.email|| !_vm.password},on:{"click":function($event){return _vm.create(_vm.email, _vm.password)}}},[_vm._v("Register")])],1),_vm._v(" "),_c('h3'),_vm._v(" "),_c('div',[_c('button',{attrs:{"variant":"primary","id":"button_login"},on:{"click":function($event){return _vm.goToLogin()}}},[_vm._v("Already have an account? Just login")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/RJs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "48c2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/voyce.b5e8d73.png";

/***/ }),

/***/ "5Q60":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.5132426.png";

/***/ }),

/***/ "9nJH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('div',{attrs:{"id":"form__container"}},[_c('form',[_c('h3'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"email","required":"","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('h3'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","required":"","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('h3'),_vm._v(" "),_c('div',[(_vm.error)?_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error)+" ")]):_vm._e()]),_vm._v(" "),_c('h3'),_vm._v(" "),_c('div',{attrs:{"id":"button_Container"}},[_c('b-button',{attrs:{"id":"button"},on:{"click":function($event){return _vm.login(_vm.email, _vm.password)}}},[_vm._v("Login")])],1),_vm._v(" "),_c('h3'),_vm._v(" "),_c('div',[_c('button',{attrs:{"id":"button_signup"},on:{"click":function($event){return _vm.goToSignUp()}}},[_vm._v("Don't have an account? Create one")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B/SA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"form__container"}},[_c('form',[_c('h3'),_vm._v(" "),_c('div',[_c('span',{attrs:{"id":"emailId"}},[_vm._v(_vm._s(_vm.email))])]),_vm._v(" "),_c('h1'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.to),expression:"to"}],attrs:{"type":"text","required":"","placeholder":"Phone number to send text to with country code"},domProps:{"value":(_vm.to)},on:{"input":function($event){if($event.target.composing){ return; }_vm.to=$event.target.value}}}),_vm._v(" "),_c('h3'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],attrs:{"type":"text","required":"","placeholder":"Message"},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}}),_vm._v(" "),_c('h3'),_vm._v(" "),_c('div',{attrs:{"id":"button_Container"}},[_c('b-button',{attrs:{"id":"button","disabled":!_vm.to || !_vm.message},on:{"click":function($event){return _vm.sendText(_vm.to, _vm.message)}}},[_vm._v("Send Text")])],1),_vm._v(" "),_c('h3'),_vm._v(" "),_c('div',[(_vm.errorReq)?_c('span',{staticClass:"spans"},[_vm._v(_vm._s(_vm.errorReq)+" ")]):_vm._e()])]),_vm._v(" "),_c('div',{attrs:{"id":"loginRegister"}},[_c('b-button',{attrs:{"id":"button"},on:{"click":function($event){return _vm.logout()}}},[_vm._v("Logout")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DGWc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__("dih4");




//configuration
var config = __webpack_require__("FhoZ");
var frontendUrl = "http://" + config.dev.host + ":" + config.dev.port;
var backendUrl = "http://" + config.dev.backendHost + ":" + config.dev.backendPort;

var AXIOS = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: backendUrl,
  headers: { "Access-Control-Allow-Origin": frontendUrl }
});

//page view
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Login",
  data: function data() {
    return {
      error: "",
      response: [],
      pageTitle: ""
    };
  },


  methods: {

    // signup page
    goToSignUp: function goToSignUp() {
      __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push({
        path: "/signup",
        name: "SignUpPage"
      });
    },

    enter: function enter() {
      __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push({
        path: "/sendtext",
        name: "FunctionPage"
      });
    },

    login: function login(email, password) {
      var _this = this;

      var auth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_firebase_auth__["a" /* getAuth */])();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_firebase_auth__["c" /* signInWithEmailAndPassword */])(auth, email, password).then(function (userCredential) {
        // Signed in 
        var user = userCredential.user;
        localStorage.setItem("savedUserEmail", email);
        _this.enter();
        _this.error = '';
      }).catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log(errorMessage.substring(10));
        // ..
        _this.error = errorMessage.substring(10);
      });
    }

  }
});

/***/ }),

/***/ "FhoZ":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {// see http://vuejs-templates.github.io/webpack for documentation.
var path = __webpack_require__("o/zv")

module.exports = {
  build: {
    env: __webpack_require__("rBKV"),
    index: path.resolve(__dirname, '../dist/index.html'),
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: __webpack_require__.i({"NODE_ENV":"production"}).npm_config_report
  },
  dev: {
    env: __webpack_require__("dhIU"),
    port: 8080,
    autoOpenBrowser: true,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc9e1876_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("/RJs");
function injectStyle (ssrContext) {
  __webpack_require__("5Q60")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc9e1876_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__("uLgv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_config_json__ = __webpack_require__("kMb3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__auth_config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth__ = __webpack_require__("SQ6o");





// Import the Auth0 configuration


// Import the plugin here


// Install the authentication plugin here
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__auth__["a" /* Auth0Plugin */], {
  domain: __WEBPACK_IMPORTED_MODULE_4__auth_config_json__["domain"],
  clientId: __WEBPACK_IMPORTED_MODULE_4__auth_config_json__["clientId"],
  onRedirectCallback: function onRedirectCallback(appState) {
    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
  }
});

var firebaseConfig = {
  apiKey: "AIzaSyBjkRekYl7u2fLbRDcUTLneXQoQTMv9Dso",
  authDomain: "conuhacks-94ce2.firebaseapp.com",
  projectId: "conuhacks-94ce2",
  storageBucket: "conuhacks-94ce2.appspot.com",
  messagingSenderId: "587913802548",
  appId: "1:587913802548:web:fe7996618156ccf1d92b61"
};

// Initialize Firebase
var app = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* initializeApp */])(firebaseConfig);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
}).$mount("#app");

/***/ }),

/***/ "PraM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"textContainer"},[_c('label',{attrs:{"id":"text"}},[_vm._v("Message the ones you love when they need you the most")]),_vm._v(" "),_c('div',{staticClass:"buttonContainer"},[_c('b-button',{staticClass:"btn",attrs:{"id":"button","variant":"primary"},on:{"click":function($event){return _vm.goToSignUp()}}},[_vm._v("Get started")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("7Otq")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__("48c2")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SQ6o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getInstance */
/* unused harmony export useAuth0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Auth0Plugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth0_auth0_spa_js__ = __webpack_require__("CkTr");







/** Define a default action to perform after authentication */
var DEFAULT_REDIRECT_CALLBACK = function DEFAULT_REDIRECT_CALLBACK() {
  return window.history.replaceState({}, document.title, window.location.pathname);
};

var instance = void 0;

/** Returns the current instance of the SDK */
var getInstance = function getInstance() {
  return instance;
};

/** Creates an instance of the Auth0 SDK. If one has already been created, it returns that instance */
var useAuth0 = function useAuth0(_ref) {
  var _ref$onRedirectCallba = _ref.onRedirectCallback,
      onRedirectCallback = _ref$onRedirectCallba === undefined ? DEFAULT_REDIRECT_CALLBACK : _ref$onRedirectCallba,
      _ref$redirectUri = _ref.redirectUri,
      redirectUri = _ref$redirectUri === undefined ? window.location.origin : _ref$redirectUri,
      options = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["onRedirectCallback", "redirectUri"]);

  if (instance) return instance;

  // The 'instance' is simply a Vue object
  instance = new __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */]({
    data: function data() {
      return {
        loading: true,
        isAuthenticated: false,
        user: {},
        auth0Client: null,
        popupOpen: false,
        error: null
      };
    },

    methods: {
      /** Authenticates the user using a popup window */
      loginWithPopup: function loginWithPopup(options, config) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.popupOpen = true;

                  _context.prev = 1;
                  _context.next = 4;
                  return _this.auth0Client.loginWithPopup(options, config);

                case 4:
                  _context.next = 6;
                  return _this.auth0Client.getUser();

                case 6:
                  _this.user = _context.sent;
                  _context.next = 9;
                  return _this.auth0Client.isAuthenticated();

                case 9:
                  _this.isAuthenticated = _context.sent;

                  _this.error = null;
                  _context.next = 17;
                  break;

                case 13:
                  _context.prev = 13;
                  _context.t0 = _context["catch"](1);

                  _this.error = _context.t0;
                  // eslint-disable-next-line
                  console.error(_context.t0);

                case 17:
                  _context.prev = 17;

                  _this.popupOpen = false;
                  return _context.finish(17);

                case 20:
                  _context.next = 22;
                  return _this.auth0Client.getUser();

                case 22:
                  _this.user = _context.sent;

                  _this.isAuthenticated = true;

                case 24:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this, [[1, 13, 17, 20]]);
        }))();
      },

      /** Handles the callback when logging in using a redirect */
      handleRedirectCallback: function handleRedirectCallback() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this2.loading = true;
                  _context2.prev = 1;
                  _context2.next = 4;
                  return _this2.auth0Client.handleRedirectCallback();

                case 4:
                  _context2.next = 6;
                  return _this2.auth0Client.getUser();

                case 6:
                  _this2.user = _context2.sent;

                  _this2.isAuthenticated = true;
                  _this2.error = null;
                  _context2.next = 14;
                  break;

                case 11:
                  _context2.prev = 11;
                  _context2.t0 = _context2["catch"](1);

                  _this2.error = _context2.t0;

                case 14:
                  _context2.prev = 14;

                  _this2.loading = false;
                  return _context2.finish(14);

                case 17:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this2, [[1, 11, 14, 17]]);
        }))();
      },

      /** Authenticates the user using the redirect method */
      loginWithRedirect: function loginWithRedirect(o) {
        return this.auth0Client.loginWithRedirect(o);
      },

      /** Returns all the claims present in the ID token */
      getIdTokenClaims: function getIdTokenClaims(o) {
        return this.auth0Client.getIdTokenClaims(o);
      },

      /** Returns the access token. If the token is invalid or missing, a new one is retrieved */
      getTokenSilently: function getTokenSilently(o) {
        return this.auth0Client.getTokenSilently(o);
      },

      /** Gets the access token using a popup window */

      getTokenWithPopup: function getTokenWithPopup(o) {
        return this.auth0Client.getTokenWithPopup(o);
      },

      /** Logs the user out and removes their session on the authorization server */
      logout: function logout(o) {
        return this.auth0Client.logout(o);
      }
    },
    /** Use this lifecycle method to instantiate the SDK client */
    created: function created() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref2, appState;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__auth0_auth0_spa_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options, {
                  client_id: options.clientId,
                  redirect_uri: redirectUri
                }));

              case 2:
                _this3.auth0Client = _context3.sent;
                _context3.prev = 3;

                if (!(window.location.search.includes("code=") && window.location.search.includes("state="))) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 7;
                return _this3.auth0Client.handleRedirectCallback();

              case 7:
                _ref2 = _context3.sent;
                appState = _ref2.appState;


                _this3.error = null;

                // Notify subscribers that the redirect callback has happened, passing the appState
                // (useful for retrieving any pre-authentication state)
                onRedirectCallback(appState);

              case 11:
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](3);

                _this3.error = _context3.t0;

              case 16:
                _context3.prev = 16;
                _context3.next = 19;
                return _this3.auth0Client.isAuthenticated();

              case 19:
                _this3.isAuthenticated = _context3.sent;
                _context3.next = 22;
                return _this3.auth0Client.getUser();

              case 22:
                _this3.user = _context3.sent;

                _this3.loading = false;
                return _context3.finish(16);

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[3, 13, 16, 25]]);
      }))();
    }
  });

  return instance;
};

// Create a simple Vue plugin to expose the wrapper object throughout the application

var Auth0Plugin = {
  install: function install(Vue, options) {
    Vue.prototype.$auth = useAuth0(options);
  }
};

/***/ }),

/***/ "UaT1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth__ = __webpack_require__("dih4");





//configuration
var config = __webpack_require__("FhoZ");
var frontendUrl = "http://" + config.dev.host + ":" + config.dev.port;
var backendUrl = "http://" + config.dev.backendHost + ":" + config.dev.backendPort;

var AXIOS = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: backendUrl,
  headers: { "Access-Control-Allow-Origin": frontendUrl }
});

//page view
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SignUp",
  data: function data() {
    var _ref;

    return _ref = {
      error: "",
      response: []
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "error", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "pageTitle", ""), _ref;
  },


  methods: {

    // Login page
    goToLogin: function goToLogin() {
      __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push({
        path: "/login",
        name: "LoginPage"
      });
    },

    create: function create(email, password) {
      var _this = this;

      var auth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_firebase_auth__["a" /* getAuth */])();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_firebase_auth__["d" /* createUserWithEmailAndPassword */])(auth, email, password).then(function (userCredential) {
        // Signed in 
        var user = userCredential.user;
        _this.goToLogin();
        _this.error = '';
      }).catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log(errorMessage.substring(10));
        // ..
        _this.error = errorMessage.substring(10);
      });
    }

  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomePage__ = __webpack_require__("wrM5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LoginPage__ = __webpack_require__("YlY5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SignUpPage__ = __webpack_require__("cga/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FunctionPage__ = __webpack_require__("wm0M");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'HomePage',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HomePage__["a" /* default */]
  }, {
    path: '/signup',
    name: 'SignUpPage',
    component: __WEBPACK_IMPORTED_MODULE_4__components_SignUpPage__["a" /* default */]
  }, {
    path: '/login',
    name: 'LoginPage',
    component: __WEBPACK_IMPORTED_MODULE_3__components_LoginPage__["a" /* default */]
  }, {
    path: '/sendtext',
    name: 'FunctionPage',
    component: __WEBPACK_IMPORTED_MODULE_5__components_FunctionPage__["a" /* default */]
  }]
}));

/***/ }),

/***/ "YlY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_Login_js__ = __webpack_require__("DGWc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e61eda5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__ = __webpack_require__("9nJH");
function injectStyle (ssrContext) {
  __webpack_require__("oTFL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_Login_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e61eda5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cga/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_SignUp_js__ = __webpack_require__("UaT1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e89b500_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpPage_vue__ = __webpack_require__("/DrB");
function injectStyle (ssrContext) {
  __webpack_require__("uV6C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_SignUp_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e89b500_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dhIU":
/***/ (function(module, exports, __webpack_require__) {

var merge = __webpack_require__("2cg0")
var prodEnv = __webpack_require__("rBKV")

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"'
})


/***/ }),

/***/ "g3yB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kMb3":
/***/ (function(module, exports) {

module.exports = {"domain":"dev-ikrrwmo3.us.auth0.com","clientId":"ycakUERgFL37BK0X1nCOcSDx6LlJXGqJ"}

/***/ }),

/***/ "oTFL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pWPe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__("dih4");




//configuration
var config = __webpack_require__("FhoZ");
var frontendUrl = "http://" + config.dev.host + ":" + config.dev.port;
var backendUrl = "http://" + config.dev.backendHost + ":" + config.dev.backendPort;

var AXIOS = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: backendUrl,
  headers: { "Access-Control-Allow-Origin": frontendUrl }
});

//page view
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Function",
  data: function data() {
    return {
      errorReq: "",
      email: "",
      response: [],
      pageTitle: ""
    };
  },


  created: function created() {
    this.email = localStorage.getItem("savedUserEmail");
    if (this.email.length == 0) {
      this.home();
    }
  },

  methods: {

    // home page
    home: function home() {
      __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push({
        path: "/",
        name: "HomePage"
      });
    },

    logout: function logout() {
      var _this = this;

      var auth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_firebase_auth__["a" /* getAuth */])();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_firebase_auth__["b" /* signOut */])(auth).then(function () {
        // Sign-out successful.
        _this.home();
        _this.errorReq = '';
        localStorage.setItem("savedUserEmail", "");
      }).catch(function (error) {
        // An error happened.
        _this.errorReq = error.message.substring(10);
      });
    },

    sendText: function sendText(to, message) {
      var _this2 = this;

      var email = localStorage.getItem("savedUserEmail");
      // check if email is not ''


      console.log("To: " + to + ", " + "message: " + message + " - from " + email);

      var url = "https://conuhacks-chat-6683.twil.io/send-request?From=" + email + "&To=" + to + "&Body=" + message + "\n - from " + this.email;

      AXIOS.get(url).then(function (response) {
        console.log("success");
        _this2.errorReq = '';
      }).catch(function (e) {
        var errorMsg = e;
        _this2.errorReq = 'Message sent successfully';
        console.log(e);
      });
    }

  }
});

/***/ }),

/***/ "q/IJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rBKV":
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"'
}


/***/ }),

/***/ "rlol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__("YaEn");



//configuration
var config = __webpack_require__("FhoZ");
var frontendUrl = "http://" + config.dev.host + ":" + config.dev.port;
var backendUrl = "http://" + config.dev.backendHost + ":" + config.dev.backendPort;

var AXIOS = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: backendUrl,
  headers: { "Access-Control-Allow-Origin": frontendUrl }
});

//page view
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Home",
  data: function data() {
    return {
      error: "",
      response: [],
      pageTitle: ""
    };
  },


  methods: {

    // login page
    goToLogin: function goToLogin() {
      __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push({
        path: "/login",
        name: "LoginPage"
      });
    },

    // signup page
    goToSignUp: function goToSignUp() {
      __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push({
        path: "/signup",
        name: "SignUpPage"
      });
    }
  }
});

/***/ }),

/***/ "uV6C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wm0M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_Function_js__ = __webpack_require__("pWPe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d41214_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FunctionPage_vue__ = __webpack_require__("B/SA");
function injectStyle (ssrContext) {
  __webpack_require__("q/IJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_Function_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d41214_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FunctionPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wrM5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_Home_js__ = __webpack_require__("rlol");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74aa4c44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__ = __webpack_require__("PraM");
function injectStyle (ssrContext) {
  __webpack_require__("g3yB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_Home_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74aa4c44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.92658f6de634f9d71943.js